import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../components';

export default function Error() {
  const navigate = useNavigate();
  return (
    <div className="p-9 text-center">
      <h4 className="text-2xl font-bold">404. Page not Found</h4>
      <div className="mt-5">
        <Button
          label="Back to HomePage"
          handleClick={() => {
            navigate('/products');
          }}
        />
      </div>
    </div>
  );
}
